// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';

const PageHeader = ({
  isLoading,
  WIN,
}) => (
  <>
        <h1 className="page_title icon_plus" style={{ fontWeight: 'bold' }}>
          {
            `${
              // eslint-disable-next-line no-nested-ternary
              isLoading
                ? 'Create And Edit'
                : WIN
                  ? 'Edit'
                  : 'Create'
            } Work Order`
          }
        </h1 >
        {
          WIN
            ? `WIN - ${WIN}`
            : ''
        }
  </>
);

export default PageHeader;
